/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { OrganizationStrictHttpResponse } from '../../organization-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrganizationBackgroundImageModel } from '../../models/organization-background-image-model';

export interface AdminFhirIdBackgroundImagePost$Params {
  fhirId: string;
      body?: OrganizationBackgroundImageModel
}

export function adminFhirIdBackgroundImagePost(http: HttpClient, rootUrl: string, params: AdminFhirIdBackgroundImagePost$Params, context?: HttpContext): Observable<OrganizationStrictHttpResponse<OrganizationBackgroundImageModel>> {
  const rb = new RequestBuilder(rootUrl, adminFhirIdBackgroundImagePost.PATH, 'post');
  if (params) {
    rb.path('fhirId', params.fhirId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as OrganizationStrictHttpResponse<OrganizationBackgroundImageModel>;
    })
  );
}

adminFhirIdBackgroundImagePost.PATH = '/Admin/{fhirId}/BackgroundImage';
